import { cn } from "@/lib/utils";
import type { CalculationResults } from "../types";
import { ProbabilityDisplay } from "./ProbabilityDisplay";
import { RiskIndicator } from "./RiskIndicator";
import { BreakdownList } from "./BreakdownList";
import { useLanguage } from "../i18n";

export interface ResultsSectionProps {
  results: CalculationResults;
  teamRerollsAvailable: number;
  className?: string;
}

export function ResultsSection({ results, teamRerollsAvailable, className }: ResultsSectionProps) {
  const { t } = useLanguage();

  return (
    <section
      className={cn(
        "bg-bb-gray-dark border-2 border-bb-gray-mid border-l-4 border-l-bb-blood-red",
        className
      )}
    >
      <div
        className={cn(
          "bg-bb-gray-mid px-4 py-3",
          "border-b border-bb-gold/30"
        )}
      >
        <h2 className="font-condensed text-xl font-bold uppercase tracking-wider text-bb-gold">
          {t.results}
        </h2>
      </div>

      <div className="p-6 sm:p-8 text-center">
        <ProbabilityDisplay probability={results.totalProbability} />

        <div className="text-bb-bone-white/70 mt-4">
          {t.teamRerollsUsed}: {results.teamRerollsUsed} / {teamRerollsAvailable}
        </div>

        <RiskIndicator probability={results.totalProbability} className="mt-6" />

        <BreakdownList breakdown={results.breakdown} />
      </div>
    </section>
  );
}
